<div class="overflow-hidden rounded-xl border border-cp-line-strong bg-cp-surface text-[13px] shadow-cp" aria-hidden="true">
  <div class="flex flex-wrap items-center justify-between gap-3 border-b border-cp-line px-5 py-3.5">
    <div class="min-w-0">
      <p class="text-[12px] text-cp-subtle">Term Request Details</p>
      <p class="mt-0.5 truncate font-[510] text-cp-ink">
        <span class="font-cp-mono text-[12px] font-normal text-cp-subtle">{{ request.ref }}</span>
        {{ request.client }}
      </p>
    </div>
    <div class="flex items-center gap-4 text-[12px] text-cp-muted">
      <span class="hidden sm:inline">{{ request.loanType }}</span>
      <span class="font-cp-mono tabular-nums text-cp-ink">{{ usd(request.amount) }}</span>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="w-full min-w-[560px] text-left">
      <thead>
        <tr>
          <th class="w-[34%] px-5 py-3 font-normal text-cp-subtle">Lender response</th>
          @for (o of options; track o.label; let i = $index) {
            <th [class]="'px-5 py-3 font-[510] ' + (i === selectedIndex ? 'bg-cp-fill text-cp-ink' : 'text-cp-muted')">
              <span class="flex items-center gap-1.5">
                {{ o.label }}
                @if (i === selectedIndex) {
                  <ng-icon name="phosphorCheck" size="13" class="text-cp-accent-fg" />
                }
              </span>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (f of fields; track f.key) {
          <tr class="border-t border-cp-line">
            <td class="px-5 py-2.5 text-cp-muted">{{ f.label }}</td>
            @for (o of options; track o.label; let i = $index) {
              <td [class]="'px-5 py-2.5 ' + (f.key === 'interestRate' ? 'font-cp-mono text-[12px] tabular-nums ' : '') + (i === selectedIndex ? 'bg-cp-fill text-cp-ink' : 'text-cp-ink/80')">
                {{ o[f.key] }}
              </td>
            }
          </tr>
        }
        <tr class="border-t border-cp-line">
          <td class="px-5 py-3"></td>
          @for (o of options; track o.label; let i = $index) {
            <td [class]="'px-5 py-3 ' + (i === selectedIndex ? 'bg-cp-fill' : '')">
              @if (i === selectedIndex) {
                <span class="inline-flex items-center gap-1.5 rounded-md bg-cp-accent-soft px-2 py-1 font-[510] text-cp-accent-fg">Offer Selected</span>
              } @else {
                <span class="inline-flex rounded-md border border-cp-line-strong px-2 py-1 text-cp-muted">Select Option</span>
              }
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>
